import React from 'react'
import Typography, { TypographyProps } from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Pattern } from '../../app/builder/contexts/PatternContext'

interface PatternVersionTitleProps extends TypographyProps {
  pattern: Pattern
  symbol?: string
  onClick?: (e: React.MouseEvent) => void
  compact?: boolean
}

const PatternVersionTitle: React.FC<PatternVersionTitleProps> = ({
  pattern,
  symbol,
  onClick,
  compact,
  ...typographyProps
}) => {
  const titleParts = [pattern.name || '', `v${pattern.version || ''}`, symbol || ''].filter(Boolean)

  return (
    <Box
      component="div"
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
        ...(onClick && {
          cursor: 'pointer',
          borderRadius: 1,
          px: 0.5,
          mx: -0.5,
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)' },
        }),
      }}
    >
      {titleParts.map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Typography variant="body1" sx={{ px: 0.5, flexShrink: 0 }} {...typographyProps}>
              -
            </Typography>
          )}
          <Typography
            variant="body1"
            sx={{
              ...(index === 0
                ? {
                    flexGrow: compact ? 0 : 1,
                    flexShrink: 1,
                    minWidth: 0,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  }
                : {
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                  }),
            }}
            {...typographyProps}
          >
            {part}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  )
}

export default PatternVersionTitle
